import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Exercice } from '../../model/exercice.model';
import { ExerciceMediaService } from '../../service/exerciceMedia.service';
import { ExerciceService } from '../../service/exercice.service';
import { EventEmitter, Output } from '@angular/core';
import { ExerciceCategoryService } from '../../service/exerciceCategory.service';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-exercice-view',
  templateUrl: './exercice-view.component.html',
  styleUrls: ['./exercice-view.component.scss']
})
export class ExerciceViewComponent implements OnInit, OnChanges {
  @Input() exercice!: Exercice;
  @Input() isEditMode: boolean = false;

  exerciceFormGroup: FormGroup;
  selectedFile?: File;
  selectedFileName: string = '';

  difficultyList = [];
  categoryList = [];

  @Output() exerciceUpdated = new EventEmitter<Exercice>();

  constructor(
    private exerciceMediaService: ExerciceMediaService,
    private exerciceService: ExerciceService,
    private exerciceCategoryService: ExerciceCategoryService
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.difficultyList = this.exerciceService.getDifficultyList();

    const _params = new HttpParams().set('status', 'active');
    this.exerciceCategoryService.getCategories(_params).subscribe(data => {
      if (data['results']) {
        this.categoryList = data['results'];
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['exercice'] && this.exercice && this.exerciceFormGroup) {
      this.exerciceFormGroup.patchValue({
        title: this.exercice.title,
        difficulty: this.exercice.difficulty,
        duration: this.exercice.duration,
        instructions: this.exercice.instruction_student,
        category: this.exercice.category.url,
      });
    }
  }

  initForm(): void {
    this.exerciceFormGroup = new FormGroup({
      title: new FormControl(this.exercice?.title || '', Validators.required),
      difficulty: new FormControl(this.exercice?.difficulty || '', Validators.required),
      duration: new FormControl({ value: this.exercice?.duration || null, disabled: true }),
      instructions: new FormControl(this.exercice?.instruction_student || '', Validators.required),
      category: new FormControl(this.exercice?.category.url || '')
    });
  }

  onFileSelected(event: Event): void {
    if (!this.isEditMode) return;

    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      this.selectedFile = input.files[0];
      this.selectedFileName = this.selectedFile.name;
    }
  }

  patchExercice(): void {
    if (!this.exercice) return;

    const form = this.exerciceFormGroup.value;
    const updatedFields = {
      title: form.title,
      instruction_student: form.instructions,
      difficulty: form.difficulty,
      category: form.category
    };

    this.exerciceService.patchExercice(this.exercice.id, updatedFields).subscribe(patched => {
      if (this.selectedFile) {
        this.uploadFile(this.exercice);
      } else {
        this.exerciceUpdated.emit(patched);
      }
    });
  }

  uploadFile(exercice: Exercice): void {
    const _params = {
      media_type: 'binary',
      source_type: 'stored',
      content_type: 'exercice',
      object_id: exercice.id,
    };

    if (this.selectedFile) {
      this.exerciceMediaService.postStoredMedia(this.selectedFile, _params).then(() => {
        this.selectedFile = undefined;
        this.selectedFileName = '';
        this.exerciceUpdated.emit(exercice);
      });
    }
  }

  downloadFile(): void {
    if (this.exercice?.media) {
      this.exerciceMediaService.downloadMedia(
        this.exercice.media,
      );
    }
  }
}
